import React, { createContext, useContext, useState, useEffect } from "react";
import dataService from "../services/dataService";

export const emptyVeny = {
    veny_szam: 1, // serial
    veny_eliorder: 1, // integer Megrendelés azonosító
    veny_receipt: "", // nvarchar(25,0) Vényszám
    veny_inscript_date: new Date().toISOString().split('T')[0], // date Felírás dátuma
    veny_expirate_date: "", // date Lejárat dátuma
    veny_nine_digit_id: "", // nvarchar(9,0) 	Kilencjegyű azonosító
    veny_med_stamp_num: "", // nvarchar(25,0) Orvosi pecsét száma
	// veny_viro_id: null, // integer VIRO azonosító
    veny_bno_code: "", // nvarchar(5,0) BNO kód	BNO kód
    veny_med_name: "", // nvarchar(50,0) Orvos neve
	// veny_custorder: null, // integer Vevői rendelés
    veny_med_id: null, // integer Orvos id
    veny_indvdl_permit_nr: null, // Egyedi kérelem száma
    veny_indvdl_permit_file: 1, // Egyedi kérelem fotó
    veny_indstrl_accdnt: null, // Üzemi baleset naplószám
	is_onefoot_meas: 0, // nvarchar(1,0) // Fél lábas mérés
	is_left: null, // nvarchar(1,0) // Bal/Jobb mérés?
	veny_shoes_med_right: "", // nvarchar(10,0) // Cipő orvosi kódja jobb
	veny_shoes_med_left: "", // nvarchar(10,0) // Cipő orvosi kódja bal
    components: []
};



// Alapértelmezett rendelés adatmodell
const defaultOrder = {
	id: null, // integer
	status: "", // nvarchar(60,0)// integer // 1: vényes, 2: telemedicina. 3: privát
	hmeliorder: {
		hmeliorder_order_type: null,
		hmeliorder_specialis_igeny: [], // nvarchar(255,0) // Speciális igények
		hmeliorder_szam: null, // integer
		hmeliorder_specific_id: "", // nvarchar(20,0)
		hmeliorder_status: 0, // integer
		hmeliorder_factory_stat_szam: 1, // integer
		hmeliorder_factory_stat_name: "", // nvarchar(60,0)
		hmeliorder_depot_szam: null, // integer
		hmeliorder_depot_prefix: "", // nvarchar(10,0)
		hmeliorder_depot_address: "", // nvarchar(255,0)
		hmeliorder_depot_city_szam: 1, // integer
		hmeliorder_depot_city_name: "", // nvarchar(60,0)
		hmeliorder_depot_city_postcode: "", // nvarchar(10,0)
		hmeliorder_order_date: "", // date
		hmeliorder_ins_date: "", // date
		hmeliorder_ins_time: "", // time
		hmeliorder_shoehorn: "", // nvarchar(60,0) // Kaptafa
		hmeliorder_shoehornmodel_id: 1,
		hmeliorder_shoehorn_remark: "", // nvarchar(255,0) // Kaptafa megjegyzés
		hmeliorder_leather_color: "", // nvarchar(255,0) // Felsőbőr színe
		hmeliorder_liner_material: "", // nvarchar(60,0) // Bélés anyaga
		hmeliorder_leather_remark: "", // nvarchar(255,0) // Alkatrész színei
		hmeliorder_facturing_process: "", // nvarchar(20,0) // Gyártási eljárás
		hmeliorder_rama: "", // nvarchar(30,0) // Ráma
		hmeliorder_foot_material: "", // nvarchar(60,0) // Talp anyag
		hmeliorder_facramafoot_remark: "", // nvarchar(255,0) // Gyártás, ráma, talp megjegyzés
		hmeliorder_corner_height: null, // decimal(5,2) // Sarok magasság(cm)
		hmeliorder_corner_material: "", // nvarchar(30,0) // Sarok anyaga
		hmeliorder_corner_type: "", // nvarchar(60,0) // Sarok típusa
		hmeliorder_is_forwardcornins: "", // nvarchar(1,0) // Belső előrevezetett sarok
		hmeliorder_is_forwardcornout: "", // nvarchar(1,0) // Külső előrevezetett sarok
		hmeliorder_stave_left_in: 0, // nvarchar(1,0) // Donga bal belső
		hmeliorder_stave_left_out: 0, // nvarchar(1,0) // Donga bal külső
		hmeliorder_stave_left_value: null, // decimal(5,2) // Donga bal(mm)
		hmeliorder_stave_right_in: 0, // nvarchar(1,0) // Donga jobb belső
		hmeliorder_stave_right_out: 0, // nvarchar(1,0) // Donga jobb külső
		hmeliorder_stave_right_value: null, // decimal(5,2) // Donga jobb(mm)
		hmeliorder_rolling_right: null, // decimal(5,2) // Gördülő jobb(mm)
		hmeliorder_rolling_left: null, // decimal(5,2) // Gördülő bal(mm)
		hmeliorder_cornerlift_right: null, // decimal(5,2) // Sarok emelés jobb(mm)
		hmeliorder_cornerlift_left: null, // decimal(5,2) // Sarok emelés bal(mm)
		hmeliorder_bayerspring_right: "", // nvarchar(1,0) // Bayer rugó jobb
		hmeliorder_bayerspring_left: "", // nvarchar(1,0) // Bayer rugó bal
		hmeliorder_stirrup_right: "", // nvarchar(1,0) // Kengyel jobb
		hmeliorder_stirrup_left: "", // nvarchar(1,0) // Kengyel bal
		hmeliorder_insole_type_right: "", // nvarchar(60,0) // Betét típusa jobb
		hmeliorder_insole_type_left: "", // nvarchar(60,0) // Betét típusa bal

		hmeliorder_insole_type_right_id: 1, // SAJÁT ÚJ MEZŐ
		hmeliorder_insole_type_left_id: 1, // SAJÁT ÚJ MEZŐ

		hmeliorder_clasp: "", // nvarchar(1,0) // Kapocs
		hmeliorder_clasp_color: "", // nvarchar(20,0) // Kapocs színe
		hmeliorder_eyelet: "", // nvarchar(1,0) // Fűzőszem
		hmeliorder_eyelet_color: "", // nvarchar(20,0) // Fűzőszem színe
		hmeliorder_shoes_remark: "", // lvarchar // Cipő megjegyzés
		hmeliorder_is_wearortop: 0, // nvarchar(1,0) // Viselt már ortopéd cipőt?
		hmeliorder_is_orderotherplace: 0, // nvarchar(1,0) // Rendelt máshol ortopéd cipőt?
		hmeliorder_is_allergie: 0, // nvarchar(1,0) // Allergia
		hmeliorder_is_takepill: 0, // nvarchar(1,0) // Szedett vízhajtót
		hmeliorder_is_doneoper: 0, // nvarchar(1,0) // Műtét
		hmeliorder_is_osselet: 0, // nvarchar(1,0) // Csontkinövés
		hmeliorder_is_sensitpart: 0, // nvarchar(1,0) // Érzékeny rész
		hmeliorder_allergie_details: "", // TODO van rá ALTER!!
		hmeliorder_butyokboseg_right: null, // decimal(5,2) // Bütyökbőség jobb(cm)
		hmeliorder_butyokboseg_left: null, // decimal(5,2) // Bütyökbőség bal(cm)
		hmeliorder_marboseg_right: null, // decimal(5,2) // Marbőség jobb(cm)
		hmeliorder_marboseg_left: null, // decimal(5,2) // Marbőség bal(cm)
		hmeliorder_sarokboseg_right: null, // decimal(5,2) // Sarokbőség jobb(cm)
		hmeliorder_sarokboseg_left: null, // decimal(5,2) // Sarokbőség bal(cm)
		hmeliorder_is_hightopshoes: "", // nvarchar(1,0) // Magas szárú cipő
		hmeliorder_bokaboseg_right: null, // decimal(5,2) // Bokabőség jobb(cm)
		hmeliorder_bokaboseg_left: null, // decimal(5,2) // Bokabőség bal(cm)
		hmeliorder_szarboseg_right: null, // decimal(5,2) // Szárbőség jobb(cm)
		hmeliorder_szarboseg_left: null, // decimal(5,2) // Szárbőség bal(cm)
		hmeliorder_szarmagassag_right: null, // decimal(5,2) // Szármagasság jobb(cm)
		hmeliorder_szarmagassag_left: null, // decimal(5,2) // Szármagasság bal(cm)
		hmeliorder_ikraboseg_right: null, // decimal(5,2) // Ikrabőség jobb(cm)
		hmeliorder_ikraboseg_left: null, // decimal(5,2) // Ikrabőség bal(cm)
		hmeliorder_footsize_right: null, // decimal(5,2) // Lábméret jobb(öltés)
		hmeliorder_footsize_left: null, // decimal(5,2) // Lábméret bal(öltés)
		hmeliorder_inraisnose_right: null, // decimal(5,2) // Belső emelés orr magasság jobb
		hmeliorder_inraiscorner_right: null, // decimal(5,2) // Belső emelés sarok magasság jobb
		hmeliorder_inraisbutyok_right: null, // decimal(5,2) // Belső emelés bütyök magasság jobb
		hmeliorder_inraisnose_left: null, // decimal(5,2) // Belső emelés orr magasság bal
		hmeliorder_inraiscorner_left: null, // decimal(5,2) // Belső emelés sarok magasság bal
		hmeliorder_inraisbutyok_left: null, // decimal(5,2) // Belső emelés bütyök magasság bal
		hmeliorder_outraisnose_right: null, // decimal(5,2) // Külső emelés orr magasság jobb
		hmeliorder_outraiscorner_right: null, // decimal(5,2) // Külső emelés sarok magasság jobb
		hmeliorder_outraisbutyok_right: null, // decimal(5,2) // Külső emelés bütyök magasság jobb
		hmeliorder_outraisnose_left: null, // decimal(5,2) // Külső emelés orr magasság bal
		hmeliorder_outraiscorner_left: null, // decimal(5,2) // Külső emelés sarok magasság bal
		hmeliorder_outraisbutyok_left: null, // decimal(5,2) // Külső emelés bütyök magasság bal
		hmeliorder_midcorner_right: null, // decimal(5,2) // Belső ékemelkedés jobb
		hmeliorder_midcorner_left: null, // decimal(5,2) // Belső ékemelkedés bal
		hmeliorder_dpaym_total: null, // decimal(12,2) // Előleg
		hmeliorder_shoes_med_right: "-", // nvarchar(10,0) // Cipő orvosi kódja jobb
		hmeliorder_shoes_med_left: "-", // nvarchar(10,0) // Cipő orvosi kódja bal
		hmeliorder_nose_brace_mater: "", // nvarchar(30,0) // Orrmerevítő anyaga
		hmeliorder_nose_brace_type: "", // nvarchar(30,0) // Orrmerevítő típusa
		hmeliorder_rind_material: "", // nvarchar(30,0) // Kéreg anyaga
		hmeliorder_rind_type: "", // nvarchar(30,0) // Kéreg típusa
		hmeliorder_stave_left_remark: "", // nvarchar(255,0) // donga bal megjegyzés
		hmeliorder_stave_right_remark: "", // nvarchar(255,0) // donga jobb megjegyzés
		hmeliorder_stave_left_total: 0, // nvarchar(1,0) // donga bal teljes hossz
		hmeliorder_stave_right_total: 0, // nvarchar(1,0) // donga jobb teljes hossz
		hmeliorder_is_reachikra_left: "", // nvarchar(1,0) // Ikra magasságot eléri bal
		hmeliorder_is_reachikra_right: "", // nvarchar(1,0) // Ikra magasságot eléri jobb
		hmeliorder_is_onefoot_meas: 0, // nvarchar(1,0) // Fél lábas mérés
		hmeliorder_is_left: "", // nvarchar(1,0) // Bal/Jobb mérés?
		hmeliorder_project: null, // integer // Project
		hmeliorder_object: null, // integer // Recept azonosító
		hmeliorder_custorder: null, // integer // Vevői rendelés
		hmeliorder_specaidtype: null, // integer // Speciális támogatás
		hmeliorder_specaidtype_national: "",
		hmeliorder_specaidtype_is_fullpriceaid: 0, // 1: teljes összegű támogatás (közgyógy, üzemi baleset) -> nincs térítési díj, nincs számla (cselispecaidtype.is_fullpriceaid)
		hmeliorder_factorystat: "", // integer // Gyártási státusz
		hmeliorder_modell_num: "",  // model_code ...!
		hmeliorder_modell_remark: "",
		hmeliorder_model_id: null, // integer // Modell azonosító
		hmeliorder_cornertype_id: null, // integer // Sarok / talp típus azonosító
		hmeliorder_footmaterial_id: null, // integer // Sarok / talp anyag azonosító
		hmeliorder_linermaterial_id: null, // integer // Bélés azonosító
		hmeliorder_colorcombine_id: null, // integer // Szín/fajta azonosító
		hmeliorder_corner_height_id: null, // integer // Sarok magasság azonosító
		hmeliorder_corn_material_id: null, // integer // Sarok anyag azonosító
		hmeliorder_modell_code: "", // nvarchar(120,0) // Modell kód
		hmeliorder_mounting_type: 1, // nvarchar(60,0) // Rögzítési típus
		hmeliorder_extra_zipper: 0, // integer // Kér cipzárt?
		hmeliorder_spn_nose_cutout: 0, // integer 
		hmeliorder_spn_hole_punch: 0, // integer
		hmeliorder_spn_deco_stitch: 0, // integer 
		hmeliorder_spn_tongue: 0, // integer
		hmeliorder_color_1: 1, // integer // Szín 1
		hmeliorder_color_2: 1, // integer // Szín 2
		hmeliorder_color_3: 1, // integer // Szín 3
		hmeliorder_plus_note: "", // Hosszú szöveges megjegyzés
		hmeliorder_sole_type: "",
		hmeliorder_sole_rama_id: 1,
		hmeliorder_rmelisolerama_sole_type_national: "",
		hmeliorder_rmelisolerama_sole_color_national: "",
		hmeliorder_rama_id: 1,
		hmeliorder_rama_type_id: 1,
		hmeliorder_rama_type_national: "",
		hmeliorder_rama_sole_color_id: 1,
		hmeliorder_rama_sole_color_national: "",

		plus_hmeliorder_is_emeles: 0, // várható emelés, plusz adat, csak localstorage-ban létezik
		plus_hmeliorder_real_model_name: "" // az a modell kód, amit inputba írunk (model_name)


	},

	partner: {
		partner_szam: 1,
		partner_type: 2,
		partner_name: "",
		partner_taj: "",
		partner_country_szam: 2,
		partner_country: "",
		partner_zip: "",
		partner_city_szam: 1,
		partner_city: "",
		partner_address: "",
		partner_email: "",
		partner_phone: "",
		partner_birthday: "",
		partner_birthplace: "",
		partner_charitycare_num: "",
		partner_charity_validdate: "",
	},

	csatolmanyok: {
		veny_labkep: null,
		veny_ambulans_lap: null,
		telemedicina_labkep: null,
		telemedicina_nyilatkozat: null,
		telemedicina_eu_kerdoiv: null,
	},

	ojote: {
		ojote_error_code: 0,
		ojote_error_message: "",
		ojote_jogviszony: "",
		ojote_jogviszony_status: "",
		ojote_trans_id: "",
		taj: "",
	},

	venyek: [
        { ...emptyVeny }
    ],

	projekt: {
		hmgenproject_szam: null,
		hmgenproject_collection_code: null
	},

	divitems: [],
	divitem_selected: null,

	aktivVenyIndex: 0,

	model_options:{
		corner_types_for_model: [],
		corner_heights_for_model: [],
		shoe_horn_models_for_model: [],
		linermaterials_for_model: [],
		colors_and_materials_for_model: [],
		mounting_types_for_model: [],
		special_needs_for_model: [],
		max_stem_height: null,
		is_open_nosed: null
	}
};

const MODEL_RESET_FIELDS = [
	"hmeliorder_modell_num",
	"hmeliorder_modell_code",
	"hmeliorder_modell_remark",
	"hmeliorder_model_id",
	"hmeliorder_object",
	"hmeliorder_cornertype_id",
	"hmeliorder_corner_height_id",
	"hmeliorder_corner_height",
	"hmeliorder_corner_material",
	"hmeliorder_corner_type",
	"hmeliorder_corn_material_id",
	"hmeliorder_footmaterial_id",
	"hmeliorder_linermaterial_id",
	"hmeliorder_colorcombine_id",
	"hmeliorder_mounting_type",
	"hmeliorder_extra_zipper",
	"hmeliorder_spn_nose_cutout",
	"hmeliorder_spn_hole_punch",
	"hmeliorder_spn_deco_stitch",
	"hmeliorder_spn_tongue",
	"hmeliorder_eyelet",
	"hmeliorder_clasp",
	"hmeliorder_rama",
	"hmeliorder_foot_material",
	"hmeliorder_facramafoot_remark",
	"hmeliorder_shoehorn",
	"hmeliorder_shoehornmodel_id",
	"hmeliorder_shoehorn_remark",
	"hmeliorder_leather_color",
	"hmeliorder_color_1",
	"hmeliorder_color_2",
	"hmeliorder_color_3",
	"hmeliorder_liner_material",
	"hmeliorder_leather_remark",
	"hmeliorder_facturing_process",
	"hmeliorder_shoes_remark",
	"hmeliorder_shoes_med_right",
	"hmeliorder_shoes_med_left",
	"hmeliorder_nose_brace_mater",
	"hmeliorder_nose_brace_type",
	"hmeliorder_rind_material",
	"hmeliorder_rind_type",
	"hmeliorder_specialis_igeny",
	"hmeliorder_sole_type",
	"hmeliorder_sole_rama_id",
	"hmeliorder_rama_id",
	"hmeliorder_rama_type_id",
	"hmeliorder_rama_type_national",
	"hmeliorder_rama_sole_color_id",
	"hmeliorder_rama_sole_color_national",
	"plus_hmeliorder_is_emeles",
	"plus_hmeliorder_real_model_name"
	
];

const cloneDefaultValue = (value) => {
	if (Array.isArray(value)) {
		return [...value];
	}
	if (value && typeof value === "object") {
		return { ...value };
	}
	return value;
};

const resetModelFieldsInOrder = (currentOrder, fields = MODEL_RESET_FIELDS) => {
	const defaultHmeliorder = defaultOrder.hmeliorder;
	const nextHmeliorder = { ...currentOrder.hmeliorder };

	fields.forEach((field) => {
		if (Object.prototype.hasOwnProperty.call(defaultHmeliorder, field)) {
			nextHmeliorder[field] = cloneDefaultValue(defaultHmeliorder[field]);
		}
	});

	return {
		...currentOrder,
		hmeliorder: nextHmeliorder
	};
};

const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
	const [order, setOrder] = useState(defaultOrder);
	const [orderLoading, setLoading] = useState(true);

	useEffect(() => {
		// Visszaállítás localStorage-ból, ha van mentett rendelés
		const savedOrderSzam = localStorage.getItem("hmeliorder_szam");
				const savedOrderData = localStorage.getItem("order");
		console.log('Saved data:', { savedOrderSzam, savedOrderData });
		
		let partnerSzam = null;
		if (savedOrderData) {
			try {
				const orderObj = JSON.parse(savedOrderData);
				partnerSzam = orderObj?.partner?.partner_szam;
				console.log('Parsed partnerSzam:', partnerSzam);
			} catch (e) {
				console.error('Error parsing order data:', e);
				partnerSzam = null;
			}
		}

		if (savedOrderSzam && savedOrderSzam !== "null" && partnerSzam) {
			console.log('Calling getOrder with:', { savedOrderSzam, partnerSzam });
			dataService.getOrder(savedOrderSzam, partnerSzam)
				.then((response) => {
					// debugger;
					console.log('getOrder response:', response);
					if (response.data?.status === "ok" && response.data?.data) {
						setOrder(response.data.data);
						// Frissítsük a localStorage-t a legfrissebb adatokkal
						localStorage.setItem("order", JSON.stringify(response.data.data));
					} else {
						console.warn('Invalid order data, clearing storage');
						localStorage.removeItem("hmeliorder_szam");
						localStorage.removeItem("order");
					}
				})
				.catch((error) => {
					console.error('Error fetching order:', error);
					localStorage.removeItem("hmeliorder_szam");
					localStorage.removeItem("order");
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			console.log('No saved order data found or invalid');
			localStorage.removeItem("hmeliorder_szam");
			localStorage.removeItem("order");
			setLoading(false);
		}
	}, []);


	const setOrderId = (hmeliorder_szam) => {
		localStorage.setItem("hmeliorder_szam", hmeliorder_szam);
	};

	const clearOrderId = () => {
		localStorage.removeItem("hmeliorder_szam");
	};

	const replaceOrder = (newOrder) => {
		resetOrder();
		updateOrder(newOrder);
	};

	const updateOrder = (updates) => {
		let nextOrderState = null;
		setOrder((prev) => {
			const updated = typeof updates === "function" ? updates(prev) : { ...prev, ...updates };
			setOrderId(updated?.hmeliorder?.hmeliorder_szam || 1);
			try {
				localStorage.setItem("order", JSON.stringify(updated));
			} catch (e) {
				console.error("Nem sikerült elmenteni a rendelést a localStorage-be:", e);
			}
			nextOrderState = updated;
			return updated;
		});
		return nextOrderState;
	};

	const resetOrder = () => {
		setOrder(defaultOrder);
		setOrderId(1);
		clearOrderId();
		localStorage.removeItem("order");
	};

	const resetModelDefaults = (fields = MODEL_RESET_FIELDS) => {
		return updateOrder((prev) => resetModelFieldsInOrder(prev, fields));
	};

	const createEmptyVeny = (inscriptDate = null) => {
        return {
            ...emptyVeny,
            veny_inscript_date: inscriptDate || new Date().toISOString().split('T')[0]
        };
    };

	   return (
		   <OrderContext.Provider
			   value={{
				   order,
				   orderLoading,
				   setOrder,
				   updateOrder,
				   replaceOrder,
				   resetOrder,
				   resetModelDefaults,
				   setOrderId,
				   clearOrderId,
				   createEmptyVeny
			   }}
		   >
			   {children}
		   </OrderContext.Provider>
	   );
};

export const useOrder = () => {
	const context = useContext(OrderContext);
	if (!context) {
		throw new Error("useOrder must be used within an OrderProvider");
	}
	return context;
};
